import axios from 'axios'

const HTTPInit = axios.create({
  baseURL: process.env.VELAEASY_API_URL
})

HTTPInit.defaults.headers.post['Content-Type'] = 'application/json'

export const HTTP = HTTPInit



// WEBPACK FOOTER //
// ./src/api/http-common-velaeasy.js